import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal, Table, Typography } from 'antd';
import dayjs from 'dayjs';
import Link from 'antd/es/typography/Link';
const CertLinkRenewalModal = (props) => {
    const formatDate = (date) => {
        const formattedDate = date === null || date === undefined
            ? null
            : dayjs(date, 'DD/MM/YYYY hh:mm:ss').format('DD-MMM-YYYY');
        return formattedDate;
    };
    const columns = [
        {
            title: 'Certificate Name',
            dataIndex: 'strServiceName',
        },
        {
            title: 'Certificate ID',
            dataIndex: 'strCertId'
        },
        {
            title: 'Issue Date',
            dataIndex: 'dtCertDate',
            render: (text) => formatDate(text)
        },
        {
            title: 'Expiration Date',
            dataIndex: 'dtCertExpDate',
            render: (text) => formatDate(text)
        },
        {
            title: 'Certificate Status',
            dataIndex: ['objCertStatus', 'strLongDesc']
        },
        {
            title: 'Renewal Status',
            dataIndex: ['objCertRenewalStatus', 'strLongDesc']
        },
        {
            title: 'Recommended Decision Date',
            dataIndex: 'dtRenewalDate',
            render: (text) => formatDate(text)
        }
    ];
    return (_jsx(Modal, { title: _jsx(Typography.Title, { level: 5, children: "Link Renewal Certificate" }), open: props.open, onCancel: props.onClose, onOk: props.updateLinkedRenewalStatus, width: 1000, children: _jsxs(_Fragment, { children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'flex-end' }, children: ["Click", _jsx(Link, { onClick: props.openDirectRenewalCert, color: "blue", children: "\u00A0here\u00A0" }), ' ', "to upload a new renewal certificate if not found in below list."] }), _jsx(Table, { scroll: {
                        x: 1400
                    }, rowSelection: {
                        type: 'radio',
                        columnTitle: 'Select',
                        onChange: props.onRowSelection
                    }, columns: columns, pagination: {
                        // Pagination configuration
                        defaultPageSize: 10,
                        // showSizeChanger: true,
                        pageSizeOptions: ['5', '10', '20', '50']
                    }, dataSource: props.data, rowKey: (record) => `${record.intUniqueCertificateId}` })] }) }));
};
export default CertLinkRenewalModal;
